'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _semanticUiReact = require('semantic-ui-react');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _resumeReview = require('redux/modules/resumeReview');

var reviewActions = _interopRequireWildcard(_resumeReview);

var _components = require('components');

var _draftJs = require('draft-js');

require('./LeftMenu.css');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonFunctions = require('../../utils/commonFunctions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./LeftMenu.scss');

var fontOptions = [{
  key: 'Open Sans',
  text: 'Open Sans',
  value: 'Open Sans'
}, {
  key: 'Roboto',
  text: 'Roboto',
  value: 'Roboto'
}, {
  key: 'Inconsolata',
  text: 'Inconsolata',
  value: 'Inconsolata'
}, {
  key: 'Lato',
  text: 'Lato',
  value: 'Lato'
}, {
  key: 'Oswald',
  text: 'Oswald',
  value: 'Oswald'
}];

var LeftMenu = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    inter_section_margin: state.templateData.inter_section_margin,
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    header_font: state.templateData.header_font,
    body_font: state.templateData.body_font,
    show_color_picker: state.company.show_color_picker,
    show_font_picker: state.company.show_font_picker,
    show_spacing_picker: state.company.show_spacing_picker,
    show_section_editor: state.templateData.show_section_editor,
    show_add_new_section: state.company.show_add_new_section,
    analyzing_text: state.templateData.analyzing_text,
    info_block: state.templateData.info_block,
    text_analysis_data: state.templateData.text_analysis_data,
    analysis_mode_on: state.templateData.analysis_mode_on,
    show_text_analysis_menu: state.company.show_text_analysis_menu,
    base_url: state.company.base_url,
    type_of_document: state.company.type_of_document,
    show_my_resumes: state.company.show_my_resumes,
    show_comment_button: state.company.show_comment_button,
    loading_review: state.resumeReview.loading,
    review_permissions: state.resumeReview.review_permissions,
    design_template_id: state.templateData.design_template_id,
    resume_review_id: state.templateData.resume_review_id,
    user_data_id: state.templateData.user_data_id,
    content_template_id: state.templateData.content_template_id,
    resume_name: state.templateData.resume_name,
    design_order: state.templateData.design_order,
    personal_info: state.templateData.personal_info,
    design_template_free: state.templateData.design_template_free,
    content_template_free: state.templateData.content_template_free
  };
}, {
  updateInterSectionMargin: templateActions.updateInterSectionMargin,
  updateHeaderFont: templateActions.updateHeaderFont,
  updateBodyFont: templateActions.updateBodyFont,
  showSectionEditor: templateActions.showSectionEditor,
  analyzeText: templateActions.analyzeText,
  highlightActionVerb: templateActions.highlightActionVerb,
  turnOnAnalysisMode: templateActions.turnOnAnalysisMode,
  changeReviewStatus: reviewActions.changeReviewStatus,
  checkResumeReview: reviewActions.checkResumeReview,
  pushState: _reactRouterRedux.push
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(LeftMenu, _Component);

  function LeftMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LeftMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LeftMenu.__proto__ || (0, _getPrototypeOf2.default)(LeftMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeItem: 'spacing',
      sectionEditorVisible: false,
      analyzing_text: false,
      show_transition: false,
      review_permissions: {},
      loading_review: false,
      open: false
    }, _this.toggleVisibility = function () {
      return _this.props.showSectionEditor(true);
    }, _this.analyzeText = function (_ref2) {
      var checked = _ref2.checked;


      if (checked) {
        _this.props.turnOnAnalysisMode(true);
        var data = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var entry = _step.value;

            var HTMLData = entry['description'];
            data[entry['id']] = {};
            var editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(HTMLData)));
            editorState.getCurrentContent().getBlockMap().map(function (contentBlock) {
              if (contentBlock.getType() == 'unordered-list-item') {
                data[entry['id']][contentBlock.getKey()] = contentBlock.getText();
              }
            });
          };

          for (var _iterator = (0, _getIterator3.default)(_this.props.info_block['PR']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.props.analyzeText(data);
        _this.props.highlightActionVerb(false);
      } else {
        _this.props.turnOnAnalysisMode(false);
      }
    }, _this.hideTransition = function () {
      return _this.setState({ show_transition: false });
    }, _this.componentWillReceiveProps = function (nextProps) {
      if (_this.state.review_permissions !== nextProps.review_permissions) {
        _this.setState({
          review_permissions: nextProps.review_permissions
        });
      }
      if (_this.state.loading_review !== nextProps.loading_review) {
        _this.setState({
          loading_review: nextProps.loading_review
        });
      }
    }, _this.sendReview = function (reviewer, checker) {
      var review_permissions = _this.state.review_permissions;

      if (review_permissions.do_review) {
        var user_data = {};
        user_data['personal'] = _this.props.personal_info;
        user_data['info'] = _this.props.info_block;
        user_data['design_template_id'] = _this.props.design_template_id;
        user_data['content_template_id'] = _this.props.content_template_id;
        user_data['design_order'] = _this.props.design_order.toString();
        user_data['inter_section_margin'] = _this.props.inter_section_margin;
        user_data['primary_color'] = _this.props.primary_color;
        user_data['secondary_color'] = _this.props.secondary_color;
        user_data['header_font'] = _this.props.header_font;
        user_data['body_font'] = _this.props.body_font;
        user_data['resume_name'] = _this.props.resume_name;
        user_data['resume_review_id'] = _this.props.resume_review_id;
        var html = (0, _commonFunctions.createHTML)(document.getElementsByClassName('documentToPrint')[0].innerHTML);
        _this.props.changeReviewStatus(review_permissions.reviewer, user_data, html);
      }
      _this.setState(function (state) {
        return { open: !state.open };
      });
    }, _this.toggleConfirm = function () {
      var review_permissions = _this.state.review_permissions;

      if (review_permissions.do_review) {
        _this.setState(function (state) {
          return { open: !state.open };
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LeftMenu, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      console.log(this.props.resume_review_id);
      this.props.checkResumeReview(this.props.resume_review_id);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (!prevProps.text_analysis_data && this.props.text_analysis_data) {
        this.setState({ show_transition: true });

        setTimeout(function () {
          _this2.setState({
            show_transition: false
          });
        }, 7000);

        (0, _jquery2.default)("html, body").animate({
          scrollTop: (0, _jquery2.default)('#PR').offset().top + 10 }, 1000);
      }
      if (prevProps.analyzing_text != this.props.analyzing_text) {
        this.setState({ analyzing_text: this.props.analyzing_text });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          activeItem = _state.activeItem,
          sectionEditorVisible = _state.sectionEditorVisible,
          analyzing_text = _state.analyzing_text,
          show_transition = _state.show_transition,
          review_permissions = _state.review_permissions,
          loading_review = _state.loading_review;


      return _react2.default.createElement(
        _semanticUiReact.Menu,
        { icon: 'labeled', vertical: true, className: 'spacing-buttons', id: 'resume-left-menu' },
        review_permissions && review_permissions.can_review && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { className: review_permissions.do_review ? "review_todo" : "review_already_done", id: 'my-resumes', name: 'spacing', active: false, onClick: function onClick(e) {
              return _this3.toggleConfirm();
            } },
          !loading_review ? _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', paddingTop: '15px', fontSize: '16px' } },
            review_permissions.do_review ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'file alternate' }),
            review_permissions.reviewer ? review_permissions.do_review ? _react2.default.createElement(
              'span',
              null,
              'Review Done'
            ) : _react2.default.createElement(
              'span',
              null,
              'Review already done'
            ) : review_permissions.do_review ? _react2.default.createElement(
              'span',
              null,
              'Send for Review'
            ) : _react2.default.createElement(
              'span',
              null,
              'Review Sent'
            )
          ) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle notch', loading: loading_review })
        ),
        _react2.default.createElement(_semanticUiReact.Confirm, {
          open: this.state.open,
          content: !review_permissions.reviewer ? 'Are you sure you want to send your resume for review?' : 'Are you sure you want to complete review?',
          onCancel: this.toggleConfirm,
          confirmButton: 'Confirm',
          onConfirm: this.sendReview
        }),
        this.props.show_my_resumes && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { id: 'my-resumes', name: 'spacing', active: false, onClick: function onClick(e) {
              return _this3.props.pushState(_this3.props.base_url + '/dashboard');
            } },
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', paddingTop: '15px', fontSize: '16px' } },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'file' }),
            'My ',
            this.props.type_of_document,
            's'
          ),
          _react2.default.createElement('div', null)
        ),
        this.props.show_spacing_picker && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { id: 'spacing-menu', name: 'spacing', active: false, onClick: this.handleItemClick },
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', fontSize: '16px' } },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'browser' }),
            'Line Spacing'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Button.Group,
              null,
              _react2.default.createElement(_semanticUiReact.Button, { color: 'black', icon: 'chevron down', className: 'down-button', onClick: function onClick() {
                  if (_this3.props.inter_section_margin >= 1) {
                    _this3.props.updateInterSectionMargin(_this3.props.inter_section_margin - 1);
                  }
                } }),
              _react2.default.createElement(_semanticUiReact.Button.Or, { text: this.props.inter_section_margin }),
              _react2.default.createElement(_semanticUiReact.Button, { color: 'black', icon: 'chevron up', className: 'up-button', onClick: function onClick() {
                  return _this3.props.updateInterSectionMargin(_this3.props.inter_section_margin + 1);
                } })
            )
          )
        ),
        this.props.show_color_picker && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { id: 'color-picker-menu', name: 'colorpicker', active: false, onClick: this.handleItemClick },
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', fontSize: '16px' } },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'theme' }),
            'Color Theme'
          ),
          _react2.default.createElement(
            'div',
            { id: 'primary-color-picker', className: 'menu-items', style: { paddingBottom: '10px' } },
            _react2.default.createElement(_components.ColorPicker, { className: 'inside-menu-items', isPrimaryColor: true, activeColor: this.props.primary_color }),
            _react2.default.createElement(
              'div',
              { className: 'inside-menu-items' },
              'Primary'
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'secondary-color-picker', className: 'menu-items' },
            _react2.default.createElement(_components.ColorPicker, { className: 'inside-menu-items', isPrimaryColor: false, activeColor: this.props.secondary_color }),
            _react2.default.createElement(
              'div',
              { className: 'inside-menu-items' },
              'Secondary'
            )
          )
        ),
        this.props.show_font_picker && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { id: 'font-menu', name: 'spacing', active: false, onClick: this.handleItemClick },
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', fontSize: '16px' } },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'browser' }),
            'Select Fonts'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '10px' } },
            _react2.default.createElement(_semanticUiReact.Dropdown, { defaultValue: this.props.header_font, placeholder: 'Header Font', style: { minWidth: "135px" }, selection: true, options: fontOptions, onChange: function onChange(e, data) {
                return _this3.props.updateHeaderFont(data.value);
              } })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Dropdown, { defaultValue: this.props.body_font, placeholder: 'Body Font', style: { minWidth: "135px" }, selection: true, options: fontOptions, onChange: function onChange(e, data) {
                return _this3.props.updateBodyFont(data.value);
              } })
          )
        ),
        this.props.show_add_new_section && this.props.type_of_document !== 'Cover Letter' && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { id: 'add-section-menu', name: 'spacing', active: false, onClick: this.toggleVisibility },
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', paddingTop: '15px', fontSize: '16px' } },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
            'Add Section'
          )
        ),
        this.props.show_text_analysis_menu && this.props.type_of_document == 'Resume' && _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { id: 'review-menu', name: 'resume_review' },
          _react2.default.createElement(_semanticUiReact.Checkbox, { toggle: true, onChange: function onChange(e, data) {
              return _this3.analyzeText(data);
            } }),
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: '15px', paddingTop: '15px', fontSize: '16px' } },
            _react2.default.createElement(_semanticUiReact.Icon, { color: analyzing_text ? 'green' : 'black', loading: analyzing_text, name: 'crosshairs' }),
            'Review Mode'
          )
        ),
        show_transition && _react2.default.createElement(
          _semanticUiReact.Message,
          { className: 'resumeAnalysis-message' },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            { className: 'analysisMessageHeader', style: { paddingTop: '0px' } },
            'Analysis Complete'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Click on the icons to view your Resume Level, Section Level and Bullet Level Analysis.'
          )
        )
      );
    }
  }]);
  return LeftMenu;
}(_react.Component)) || _class);
exports.default = LeftMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LeftMenu/LeftMenu.js
// module id = 1738
// module chunks = 0